import React from "react";
import { ActionItemButton, FilterList } from "@conserveit/blocks";
import { ArrowChevronRight } from "./IconRight";
import {
  SitesBoxWrapper as BoxWrapper,
  BoxHeading,
  SitesBoxContent,
  BoxHeader,
} from "../ProjectSettings.styles";

interface ButtonProps {
  project: Insite.Project;
  isActive: boolean;
  onClick(): void;
}

// TODO: The icon is what causes the poor render performance
const Button = React.memo<ButtonProps>(
  ({ project, isActive, onClick }) => {
    return (
      <ActionItemButton
        key={project.jira_key}
        isActive={isActive}
        onClick={onClick}
        iconRight={<ArrowChevronRight tiny />}
      >
        {project.project_name}
      </ActionItemButton>
    );
  },
  (prevProps, nextProps) => prevProps.isActive === nextProps.isActive
);

interface Props {
  projectList: Insite.Project[];
  activeProject: keyof Insite.AppState["userSites"]["projects"];
  onProjectSelect(projectKey: string): () => void;
}

const ProjectsBox = React.memo<Props>(
  (props) => {
    const { onProjectSelect, activeProject, projectList } = props;

    return (
      <BoxWrapper>
        <BoxHeader>
          <BoxHeading>Projects</BoxHeading>
        </BoxHeader>
        <FilterList<Insite.Project>
          filterKey="project_name"
          filterDelay={500}
          items={projectList}
        >
          {({ visible }: { visible: Insite.Project[] }) => {
            return (
              <SitesBoxContent>
                {visible.map((project: Insite.Project) => (
                  <Button
                    key={project.jira_key}
                    project={project}
                    isActive={project.jira_key === activeProject}
                    onClick={onProjectSelect(project.jira_key)}
                  />
                ))}
              </SitesBoxContent>
            );
          }}
        </FilterList>
      </BoxWrapper>
    );
  },
  (p, n) => p.activeProject === n.activeProject
);

export default ProjectsBox;
